import React from 'react';
import { Box, Stack, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function SilhouetteCarousel({
  silhouettes,
  silhouetteImage,
  currentSilhouetteStartIndex,
  silhouettesPerPage,
  onSelect,
  onPrev,
  onNext,
}) {
  return (
    <Box 
      sx={{
        position: 'absolute',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        p: 1.5,
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(16px)',
        borderRadius: 2,
        zIndex: 20,
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center'
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
        <IconButton 
          onClick={onPrev} 
          disabled={currentSilhouetteStartIndex === 0}
          sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.10)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.25)' } }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        {silhouettes.slice(currentSilhouetteStartIndex, currentSilhouetteStartIndex + silhouettesPerPage).map(sil => (
          <Box 
            key={sil.name} 
            onClick={() => onSelect(sil.src)}
            sx={{
              width: 60,
              height: 60,
              backgroundImage: `url(${sil.src})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'rgba(255,255,255,0.08)',
              border: silhouetteImage === sil.src ? '2px solid #7C3AED' : '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px',
              cursor: 'pointer',
              m: 0.5,
              transition: 'background-color 0.3s, border-color 0.3s',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.3)',
              }
            }}
          />
        ))}

        <IconButton 
          onClick={onNext} 
          disabled={currentSilhouetteStartIndex >= silhouettes.length - silhouettesPerPage}
          sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.10)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.25)' } }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}
